import ExpandablePanel from 'components/common/ExpandablePanel';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { cloneElement } from 'react';
import { identity } from 'ramda';
import EndAdornment from '../EndAdornment';
import FormikFSPConfigExpandablePanelContent from './FormikFSPConfigExpandablePanelContent';
import useShowProgress from './useShowProgress';
import useTitle from './useTitle';
import useFormikProps from './useFormikProps';
import { useHasPermission } from '../../../../../../../hooks';
import { FULL_ACCESS_IMPLEMENTATION } from '../../../../../../common/permissions';

const FormikFSPConfigExpandablePanel = ({
  EndAdornment,
  children,
  code,
  fspConfigInitValues,
  fspConfigKey,
  keys,
  label,
  offOn,
  onBeforeSubmit,
  subTitle,
  validationSchema,
  ...props
}) => {
  const inputProps = {
    fspConfigInitValues,
    fspConfigKey,
    keys,
    offOn,
    onBeforeSubmit,
  };
  const [initialValues, handleSubmit, ref] = useFormikProps(inputProps);
  const [title, handleChange] = useTitle(label);
  const showProgress = useShowProgress();
  const hasPerm = useHasPermission([FULL_ACCESS_IMPLEMENTATION]);

  return (
    <Formik
      {...props}
      enableReinitialize
      initialValues={initialValues}
      innerRef={ref}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      <ExpandablePanel
        endAdornment={hasPerm ? <EndAdornment /> : null}
        fullHeight={false}
        name={code}
        showProgress={showProgress}
        subTitle={subTitle}
        title={title}
      >
        <FormikFSPConfigExpandablePanelContent format={onBeforeSubmit}>
          {cloneElement(children, { onChange: handleChange })}
        </FormikFSPConfigExpandablePanelContent>
      </ExpandablePanel>
    </Formik>
  );
};

FormikFSPConfigExpandablePanel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  code: PropTypes.string.isRequired,
  EndAdornment: PropTypes.func,
  fspConfigKey: PropTypes.string,
  fspConfigInitValues: PropTypes.func,
  keys: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string.isRequired,
  offOn: PropTypes.string,
  onBeforeSubmit: PropTypes.func,
  subTitle: PropTypes.string,
  validationSchema: PropTypes.object,
};

FormikFSPConfigExpandablePanel.defaultProps = {
  EndAdornment,
  fspConfigKey: null,
  fspConfigInitValues: null,
  keys: null,
  offOn: undefined,
  onBeforeSubmit: identity,
  subTitle: undefined,
  validationSchema: undefined,
};

export default FormikFSPConfigExpandablePanel;
